import apiService from "./apiService";

export const getAllBrands = () => apiService.get("/brands");
export const getBrandById = (id) => apiService.get(`/brands/${id}`);
export const createBrand = (data) => apiService.post("/brands", data);
export const updateBrand = (id, data) => apiService.put(`/brands/${id}`, data);
export const deleteBrand = (id) => apiService.delete(`/brands/${id}`);
